<template>
  <div id="home">
    <div class="overlay"></div>
    <Navbar />

    <b-carousel
      id="carousel"
      fade
      :interval="4000"
    >
      <b-carousel-slide
        v-for="(slide, i) in $store.state.slides"
        v-bind:key="i"
        class="c-img"
        :style="'background: url(' + slide + ') no-repeat center center fixed;background-size: cover;'"
      ></b-carousel-slide>
    </b-carousel>

    <div class="banner-container">
      <div class="banner-text">
        <h1>The Frizlen Group</h1>
        <p class="lead">Creating quality environments of timeless beauty and significant value.</p>
        <b-btn
          to="portfolio"
        >
          View Portfolio
        </b-btn>
      </div><!-- /.banner-text -->
    </div><!-- /.banner-container -->

    <a href="https://buffalofts.com" target="_blank" class="buffalofts-cta">
      <p>Explore our developments:</p>
      <img src="/static/buffalofts.png" />
    </a><!-- /.buffalofts-cta -->

    <div id="newsSlider">
      <span class="news-title">Recent News:</span>
      <div
        v-for="newsItem in news"
        class="feed-pill clickable mr-2"
        @click="openNews(newsItem)"
      >
        <div class="img-container">
          <img
            :src="newsItem.featured_image"
          />
        </div><!-- /.img-container -->
        <div class="p-container">
          <p>{{ newsItem.title }}</p>
        </div><!-- /.p-container -->
      </div><!-- /.feed-pill -->
      <router-link :to="{ name: 'News' }">
        <div class="feed-pill clickable news-link">
          <div class="img-container">
            <img
              src=""
            />
          </div><!-- /.img-container -->
          <div class="p-container">
            <p><i class="fas fa-newspaper"></i> <i class="fas fa-arrow-right"></i></p>
          </div><!-- /.p-container -->
        </div><!-- /.feed-pill -->
      </router-link>
    </div><!-- /#newsSlider -->

    <transition name="fade">
      <NewsItem
        v-if="showNews == true"
        :newsItem="selectedNews"
        v-on:closeNewsItem="showNews = false"
      />
    </transition>

  </div><!-- /#home -->
</template>

<script>
import Navbar from './Navbar'
import NewsItem from './NewsItem'
import axios from 'axios'

export default {
  data () {
    return {
      news: [],
      selectedNews: {},
      showNews: false
    }
  },
  components: {
    Navbar,
    NewsItem
  },
  created() {
    this.getNewsItems()
  },
  methods: {
    getNewsItems (filter) {
      this.loading = true
      let timeStamp = new Date().getTime()
      let url = 'https://buffalofts.com/api/news?&timestamp=' + timeStamp
      axios.get(url).then(response => {
        for (let i = 0; i < 3; i++) {
          this.news.push(response.data[i])
        }
        this.loading = false
      })
    },
    openNews (news) {
      this.selectedNews = news
      this.showNews = true
    }
  }
}
</script>

<style scoped>
#carousel {
  max-height: 100vh;
  overflow:hidden;
  height: 100vh;
}
.c-img {
  height: 100vh;
}
.banner-container {
  position: absolute;
  top: 33vh;
  z-index: 2;
  width: 100%;
}
.banner-text {
  z-index: 2;
  max-width: 450px;
  text-align: center;
  margin: auto;
  color: white;
}

.buffalofts-cta {
  position: absolute;
  bottom: 30px;
  right: 50px;
  z-index: 2;
  transition: all 0.1s ease-in-out;
}
.buffalofts-cta:hover {
  transform: scale(1.1);
}
.buffalofts-cta p {
  color: #eee;
  font-size: 12px;
  margin-bottom: 0;
  text-align: center;
}
.buffalofts-cta img {
  width: 150px;
}

#newsSlider {
  position: fixed;
  left: 10px;
  bottom: 10px;
  z-index: 2;
}

#newsSlider .feed-pill {
  position: relative;
  display: inline-block;
  background-color: #eee;
  border-radius: 50px;
  font-size: 12px;
  width: 190px;
  transition: all 0.2s ease-in-out;
}

#newsSlider .feed-pill:hover {
  box-shadow: 1px 2px 5px rgba(0,0,0,0.95);
  transform: scale(1.03);
}

#newsSlider .img-container {
  width: 50px;
  height: 50px;
  display: inline-block;
  padding: 5px;
}

#newsSlider img {
  object-fit: cover;
  width: 40px;
  height: 40px;
  border-radius: 50px;
}

#newsSlider .p-container {
  position: absolute;
  left: 50px;
  top: 15px;
  display: inline-block;
  width: 200px;
}

#newsSlider p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
}

#newsSlider .news-link {
  width: 50px;
  height: 50px;
  bottom: 0;
  text-align: center;
}

#newsSlider .news-link img {
  opacity: 0;
}

#newsSlider .news-link .p-container {
  left: 0px;
}

#newsSlider .news-link p {
  width: 50px;
  color: #333;
}

#newsSlider .news-title {
  display: block;
  color: #eee;
  padding-left: 5px;
  font-size: 12px;
}

@media(max-width:860px) {
  #newsSlider .feed-pill {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue